module.exports = __webpack_public_path__ + "static/images/all-errors-fixed.2OZgGS7.svg";